import ResidentialComplex from '@/services/api/residentComplex';

export default {
  namespaced: true,
  state: {
    complex: [],
    managementGroup: {},
  },
  getters: {
    complex: state => state.complex,
  },
  mutations: {
    setComplex: (state, payload) => {
      state.complex = payload;
    },
  },
  actions: {
    getComplex (state) {
      return new Promise((resolve, reject) => {
        ResidentialComplex.getComplex()
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    viewComplex (state, id) {
      return new Promise((resolve, reject) => {
        ResidentialComplex.viewComplex(id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateComplex (state, { id, value }) {
      return new Promise((resolve, reject) => {
        ResidentialComplex.updateComplex(id, value)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    createComplex (state, params) {
      return new Promise((resolve, reject) => {
        ResidentialComplex.createComplex({ ...params })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    deleteComplex (state, id) {
      return new Promise((resolve, reject) => {
        ResidentialComplex.deleteComplex(id)
          .then((response) => {
            resolve(response);
          })
          .catch(error => reject(error));
      });
    },
  },
};
